import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { StoreService } from '../Services/store.service';
import { UserService } from '../Services/user.service';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-stores',
  standalone: true,
  imports: [HttpClientModule, CommonModule, FormsModule],
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.css'],
  providers: [StoreService, UserService],
})
export class StoresComponent implements OnInit {
  stores: any;
  storeSearchTerm: string = '';
  storeName: string = '';
  storeAddress: string = '';
  storeContact: string = '';
  storeIpAddress: string = '';
  storeEmail: string = '';
  selectedStoreId: number | null = null;
  name: string = '';
  email: string = '';
  ipAddress: string = '';
  selectedRole: string = '';
  token: string = '';
  username: string = '';
  password: string = '';
  isToken: boolean = false;
  disabled: boolean = false;
  hoveredStore: string | null = null;
  loading: boolean = true;

  storeAdmins: any[] = [];
  selectedAdminStoreId: number | null = null;
  isLoadingAdmins = false;

  // Pagination
  pageNumber: number = 1;
  pageSize: number = 15;
  paginatedStores: any[] = [];

  constructor(
    private _storeService: StoreService,
    private _userservice: UserService,
  ) {}

  ngOnInit(): void {
    this.getAllStores();
  }

  getAllStores() {
    this.loading = true;
    this._storeService.getStores().subscribe((response: any) => {
      console.log(response);
      this.stores = response.result;
      this.loading = false;
      this.updatePaginatedStores();
    });
  }

  // filteredStores(): any[] {
  //   const term = this.storeSearchTerm.trim().toLowerCase();
  //   return this.stores.filter((store : any) =>
  //     store.name?.toLowerCase().includes(term) || store.email?.toLowerCase().includes(term)
  //   );
  // }

  filteredStores() {
    if (!this.stores) return [];

    const term = this.storeSearchTerm.toLowerCase();

    return this.stores.filter((user: any) => {
      return (
        user.name?.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term)
      );
    });
  }

  addStore(): void {
    const storeInfo = {
      name: this.storeName,
      email: this.storeEmail,
      address: this.storeAddress,
      contact: this.storeContact,
      ipAddress: this.storeIpAddress,
    };

    this._storeService.addNewStore(storeInfo).subscribe({
      next: () => {
        this.getAllStores();
        // this.token = res.apiKey;
        // this.isToken = true;
        // this.disabled = true;
        //Swal.fire('Success', 'Store added successfully', 'success');
        Swal.fire('Success', 'Store added successfully', 'success').then(() => {
          const modalElement = document.getElementById('staticBackdrop');
          if (modalElement) {
            let modalInstance =
              bootstrap.Modal.getInstance(modalElement) ||
              new bootstrap.Modal(modalElement);
            modalInstance.hide();
          }
          this.cleanUpModalBackdrop();
        });
      },
      error: (err) => {
        console.error('Error adding store:', err);
        Swal.fire('Error', 'Error adding store', 'warning');
      },
    });
  }
  cleanUpModalBackdrop(): void {
    document.body.classList.remove('modal-open');
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      backdrops[0].parentNode?.removeChild(backdrops[0]);
    }
  }

  openAddUserModal(storeId: number): void {
    this.selectedStoreId = storeId;
    const modalElement = document.getElementById('addUserModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  addUser(): void {
    if (!this.selectedStoreId) {
      Swal.fire('Error', 'No store selected to add user.', 'warning');
      return;
    }
    const userInfo = {
      name: this.name,
      email: this.email,
      ipAddress: this.ipAddress,
      storeId: this.selectedStoreId,
      roleToAssign: this.selectedRole,
    };
    console.log('role: ', userInfo.roleToAssign);
    this._userservice.addNewUser(userInfo).subscribe({
      next: (res: any) => {
        // this.getAllUsers();
        this.token = res.apiKey;
        this.username = res.user;
        this.password = res.password;
        this.isToken = true;
      },
      error: (err) => {
        console.error('Error adding user:', err);
        Swal.fire({
          text: `Error adding user: ${err}`,
          icon: 'warning',
          timer: 2000,
          confirmButtonText: 'OK',
        });
      },
    });
    this.disabled = true;
  }

  deleteStore(storeId: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, deactivate it!',
    }).then((result) => {
      if (result.isConfirmed) {
        this._storeService.deleteStore(storeId).subscribe({
          next: () => {
            this.getAllStores();
            Swal.fire('Deleted!', 'Store has been deactivated.', 'success');
          },
          error: (err) => {
            console.error('Error deleting store:', err);
            Swal.fire('Error', 'Failed to delete the store.', 'error');
          },
        });
      }
    });
  }

  copyToken(): void {
    let combinedText = '';
    if (this.selectedRole === 'StoreUser') {
      combinedText = `Username: ${this.username}\nPassword: ${this.password}`;
    } else if (this.selectedRole === 'StoreAdmin') {
      combinedText = `Token: ${this.token}\nUsername: ${this.username}\nPassword: ${this.password}`;
    }
    navigator.clipboard.writeText(combinedText).then(
      () => {
        Swal.fire('Copied!', 'Details copied to clipboard', 'success');
      },
      (err) => {
        console.error('Clipboard copy failed:', err);
        Swal.fire('Error', 'Could not copy token', 'error');
      },
    );
  }

  onModalClose(): void {
    this.storeName = '';
    this.storeEmail = '';
    this.storeIpAddress = '';
    this.storeAddress = '';
    this.storeContact = '';
    this.name = '';
    this.email = '';
    this.ipAddress = '';
    this.token = '';
    this.username = '';
    this.password = '';
    this.isToken = false;
    this.disabled = false;
    this.selectedRole = '';
    this.selectedStoreId = null;
  }

  openStoreAdmins(storeId: number): void {
    this.selectedAdminStoreId = storeId;
    this.storeAdmins = [];
    this.isLoadingAdmins = true;

    const modalElement = document.getElementById('storeAdminsModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }

    this._storeService.getStoreAdmins(storeId).subscribe({
      next: (res: any) => {
        this.storeAdmins = res.result || [];
        console.log(this.storeAdmins)
        this.isLoadingAdmins = false;
      },
      error: () => {
        this.isLoadingAdmins = false;
        Swal.fire('Error', 'Unable to load store admins', 'error');
      },
    });
  }

  copyAdminToken(token: string): void {
    navigator.clipboard.writeText(token).then(() => {
      Swal.fire('Copied!', 'API key copied successfully', 'success');
    });
  }

  maskApiKey(token: string): string {
    if (!token || token.length < 8) return '***********';

    const start = token.substring(0, 3);
    const end = token.substring(token.length - 3);

    return `${start}****${end}`;
  }

  activateStore(storeId: number): void {
    Swal.fire({
      title: 'Activate store?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Activate',
    }).then((result) => {
      if (result.isConfirmed) {
        this._storeService.activateStore(storeId).subscribe({
          next: () => {
            Swal.fire('Activated', 'Store activated successfully', 'success');
            this.getAllStores();
          },
          error: () => {
            Swal.fire('Error', 'Unable to activate store', 'error');
          },
        });
      }
    });
  }

  // Pagination
  onSearchChange(): void {
    this.pageNumber = 1;
    this.updatePaginatedStores();
  }

  updatePaginatedStores(): void {
    const startIndex = (this.pageNumber - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedStores = this.filteredStores().slice(startIndex, endIndex);
  }

  totalPages(): number {
    return Math.ceil(this.filteredStores().length / this.pageSize);
  }

  visiblePages(): number[] {
    const total = this.totalPages();
    const current = this.pageNumber;
    let start = Math.max(current - 1, 1);
    let end = Math.min(start + 2, total);

    if (end - start < 2) {
      start = Math.max(end - 2, 1);
    }

    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  goToPage(page: number): void {
    if (page !== this.pageNumber) {
      this.pageNumber = page;
      this.updatePaginatedStores();
    }
  }

  nextPage(): void {
    if (this.pageNumber < this.totalPages()) {
      this.pageNumber++;
      this.updatePaginatedStores();
    }
  }

  previousPage(): void {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.updatePaginatedStores();
    }
  }
}
